import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import IdleTimerComponent from "../components/IdleTimerComponent";
import Layout from "../components/Layout/Layout";
// import NotFoundPage from "../components/NotFoundPage";
import { shallowEqual } from "react-redux";
import { AppState } from "store/configureStore";
import Loader from "../components/Loader";
import { roles } from "../util/config/roles";
import Redirect from "./Redirect";
import { pageAllowed } from "./utils";

import DashboardPage from "../pages/Dashboards/DashboardPage";

import PasswordPage from "../pages/Login/PasswordPage";
import CandidateDashboardPage from "../pages/CandidateDashboard/CandidateDashboardPage";
import TestPage from "../pages/TestPage";

const AppNavigator = () => {
    const role = roles();

    const contract = useSelector(
        (state: AppState) => state.entities.contracts.selectedContract.data,
        shallowEqual
    );
    const { list: contractTypePageSetup, loading } = useSelector(
        (state: AppState) => state.entities.contracts.contractTypePageSetup,
        shallowEqual
    );
    const { itemIds } = useSelector(
        (state: AppState) => state.entities.sidebar,
        shallowEqual
    );

    const routeAllowed = (itemCode: string) =>
        pageAllowed(itemCode, contract, contractTypePageSetup, itemIds);

    return (
        <>
            <IdleTimerComponent />

            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<CandidateDashboardPage />} />
                    <Route path="candidate-dashboard" element={<Navigate to="/" replace />} /> 
                    <Route path="/test-page" element={<TestPage />} />

                    {/*<Route path="/candidate-dashboard"
                    {/*     element={<CandidateDashboardPage />} />*/}
                    {loading ? (
                        <Route path="*" element={<Loader />} />
                    ) : (
                        <Route path="*" element={<CandidateDashboardPage />} />
                    )}
                </Route>
                <Route path="/Password" element={<PasswordPage />} />
                <Route
                    path="/colApp"
                    element={<Redirect url="https://mes.columbusportals.com" />}
                />
                <Route
                    path="/staffLogicApp"
                    element={<Redirect url="https://www.stafflogic.ee/" />}
                />
            </Routes>
        </>
    );
};

export default AppNavigator;
